import React, { useState } from "react";

import MasterTable from "../../../views/dashboard/widget/MasterTabel";
import {
 
  getHostelUsersList,
} from "../../../services/OrganisationServices/hostelManagmentService";

const HostelUsersTable = ({hostelId}) => {
  return (
    <MasterTable
      getTableData= {getHostelUsersList}
      tab1={"Hostel"}
      hostelId={hostelId}
      tab2={"Hostel Users"}
      externalPermis= { {
        POST: 0,
        GET: 1,
        PUT: 0,
        DELETE: 0,
        PATCH: 0,
      }}
          //   deleteRow={deleteHostel}
    />
 
  );
};

export default HostelUsersTable;
